import { pickupNumbersUrl } from './resources.js'
import common from './common.js'

//
//Always get current restaurant from the store
//
async function getPickupNumberByRestaurant(id) {

    let restaurantid = id;
    let url = `${pickupNumbersUrl}/get/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response });
    return data;
}



export default {
    name: 'pickupNumbersService',
    getPickupNumberByRestaurant,
}